import { CSSObject } from "@emotion/react";
import { ToggleButton } from "@newsela/angelou";
import { actionNames, objectTypes, withTrackEvent } from "@newsela/snitch";
import { partialCtaDefaultLinearGradientBackground } from "../AiComponents.style";

interface AIToggleProps {
  pressed: boolean;
  onToggle: () => void;
  ariaLabel?: string;
  labelText?: string;
  qaSelector?: string;
  description?: string;
}

const ToggleWithTrackEvent = withTrackEvent(ToggleButton);

const AIToggle = ({
  pressed,
  onToggle,
  ariaLabel = "Search with Luna",
  labelText = "Search with Luna",
  qaSelector = "search-with-luna-toggle",
  description = "Toggle Search with Luna",
}: AIToggleProps) => {
  const defaultSwitchContainerCss: CSSObject = {
    ...partialCtaDefaultLinearGradientBackground,
  };
  return (
    <ToggleWithTrackEvent
      ariaProps={{
        "aria-label": ariaLabel,
        "aria-pressed": pressed,
      }}
      label={labelText}
      __cssFor={{
        switchContainerStyles: pressed ? defaultSwitchContainerCss : undefined,
      }}
      dataProps={{
        "data-qa-selector": qaSelector,
        "data-state": pressed ? "on" : "off",
      }}
      objectType={objectTypes.user}
      actionName={actionNames.interact}
      streamProperties={{
        description,
      }}
      pressed={pressed}
      onClick={onToggle}
    />
  );
};

AIToggle.displayName = "AIToggle";

export default AIToggle;
